import Parent from '../../components/parent/Parent'
import Title from '../../components/pageTitle/Title'
import './ethics.css'

export default function Ethics(){
    return (
        <Parent slider={false}>
            <div className="content">
                <Title title='أخلاقيات النشر'/>
                <div>
                    <h3 className="pTitle">مبادئ البحث والنشر العلمي:</h3>
                    <p>على الباحثيـن الراغبيـن في نشر أبحاثهم ودراساتهم في المجلة الدولية لنشر الأبحاث العلمية الالتزام بما يلي:</p>
                    <ul>
                        <li>
                            تقديم <strong>بحث أصيل</strong> وبشكل <strong>علمي متناسق</strong> يطابق مواصفات البحوث المحكمة، 
                            مع مراعاة شروط وسياسات النشر في المجلة.
                        </li>
                        <li>
                         <strong>الأمانة والدقة </strong>في توثيق البيانات والنتائج وتحليلها ونشرها.
                        </li>
                        <li>
                            تجنب <strong>أي تضارب في المصالح</strong> كدعم جهات خاصة ذات أجندة أو الارتباط مع جهات ذات مصالح خاصة.
                        </li>
                        <li>
                            المساهمة في <strong>التنمية المجتمعية</strong> وتقديم بحث ذو قيمة علمية إضافية في مجال البحث.
                        </li>
                        <li>
                            الدقة في التوثيق والاستدلال بالمراجع ونسب <strong>الآراء إلى أصحابها ومؤلفيها</strong>.
                        </li> 
                    </ul>
                </div>
                <div>
                    <h3 className="pTitle">قرارات النشر:</h3>
                    <p>
                    هيئة التحرير مسؤولة عن الموافقة على نشر الأوراق العلمية المقدمة إلى المجلة.
                    </p>
                    <p>
                    يتم تقييم الأوراق المقدمة إلى المجلة للتأكد من أنها تفي بجميع معايير البنود والشروط المنشورة في المجلة بغض النظر عن العرق والجنس والخلفية الدينية والعرق والجنسية والفلسفة السياسية.
                    </p>
                    <p>
                    ما يؤخذ في الاعتبار هو القيمة العلمية والمعايير الأخلاقية للعمل وسلامة البحث العلمي واللغة والاستشهاد والانتحال.
                    </p>
                    <p>
                    تلتزم لجنة التحرير بتحسين الرصانة العلمية للمجلة من خلال نشر البحوث وفقًا لأهميتها ووضوحها وصحتها ومطابقتها للشروط والأحكام المنصوص عليها للباحثين.
                    </p>
                </div>
                <div>
                    <h3 className="pTitle">سرية المعلومات:</h3>
                    <p>
                    يتعهد رئيس وأعضاء لجنة التحرير بعدم الكشف عن أي معلومات تتعلق بالوثائق أو الأوراق المقدمة إلى المجلة باستثناء المعلومات الضرورية التي أذن بها المؤلفون والمحررون والاستشاريون والناشر.
                    </p>
                </div>
                <div>
                    <h3 className="pTitle">مسؤوليات المراجعين والمحكمين:</h3>
                    <p>
                    يساعد المراجعون والمحكمون في المجلة لجنة التحرير في اتخاذ القرار المناسب فيما يتعلق بالبحث، وكذلك مساعدة المؤلف على تحسين بحثه.
                    </p>
                    <p>
                    تلتزم لجنة التحرير في المجلة بعدم الكشف عن أسماء المحكمين، إلا بموافقة مكتوبة من المراجعين أنفسهم.
                    </p>
                </div>
                <div>
                    <h3 className="pTitle">الموضوعية في معايير التحكيم:</h3>
                    <p>
                    المعايير الموضوعية في التحكيم ضرورية، ولا ينبغي تجاهل الأحكام الشخصية تجاه المؤلفين وتجاهلها.
                    </p>
                    <p>
                    يجب تعزيز المراجعة بآراء واضحة وحجج علمية، ويجب أن تكون متوافقة مع لوائح المجلة والمعايير والشروط المنشورة.
                    </p>
                    <p>
                    تلتزم المجلة بإصلاح جميع الأخطاء الفنية أو الناتجة عن عملية النشر أو أي تعديلات قد يطلبها الباحث من المجلة.
                    </p>
                </div>
            </div>
        </Parent>
    )
}